import amexUrl from "@/assets/cardBrand/amex.jpeg";
import dinersUrl from "@/assets/cardBrand/diners.jpeg";
import discoverUrl from "@/assets/cardBrand/discover.jpeg";
import jcbUrl from "@/assets/cardBrand/jcb.jpeg";
import mastercardUrl from "@/assets/cardBrand/mastercard.jpeg";
import visaUrl from "@/assets/cardBrand/visa.jpeg";

export const getCardBrandImgURL = (brand: string) => {
  switch (brand) {
    case "visa":
      return visaUrl;
    case "mastercard":
      return mastercardUrl;
    case "amex":
      return amexUrl;
    case "discover":
      return discoverUrl;
    case "diners":
      return dinersUrl;
    case "jcb":
      return jcbUrl;
    default:
      return "Unknown";
  }
};
